import { jwtDecode } from 'jwt-decode';

interface JWTPayload {
  exp?: number;
  [key: string]: any;
}

/**
 * Decodes a JWT token and returns its payload
 * @param token JWT token to decode
 * @returns Decoded JWT payload
 */
export const decodeJWT = <T extends JWTPayload = JWTPayload>(token: string): T => {
  try {
    return jwtDecode<T>(token);
  } catch (error) {
    throw new Error('Invalid JWT token');
  }
};

/**
 * Checks if a JWT token has expired
 * @param token JWT token to check
 * @returns boolean indicating if the token has expired
 */
export const isJWTExpired = (token: string): boolean => {
  try {
    const decoded = decodeJWT(token);
    if (!decoded.exp) return false;
    
    // Convert expiration time to milliseconds and compare with current time
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch (error) {
    return true; // If token is invalid, consider it expired
  }
};
